import { TranslationKeys } from 'locales/translationKeys'
import { StaticImageData } from 'next/image'
import tellUs from '../../../../../public/assets/home/tell-us-about-your-pet.webp'
import doorStep from '../../../../../public/assets/home/check-your-doorstep.webp'
import tailWags from '../../../../../public/assets/home/enjoy-the-tail-wags.webp'

export type Step = {
  imageSrc: StaticImageData
  number: TranslationKeys
  action: TranslationKeys
  description: TranslationKeys
  imageAlt: TranslationKeys
}

export const defaultSteps: Step[] = [
  {
    imageSrc: tellUs,
    number: 'home:how-it-works.steps.0.number',
    action: 'home:how-it-works.steps.0.action',
    description: 'home:how-it-works.steps.0.description',
    imageAlt: 'home:how-it-works.steps.0.image',
  },
  {
    imageSrc: doorStep,
    number: 'home:how-it-works.steps.1.number',
    action: 'home:how-it-works.steps.1.action',
    description: 'home:how-it-works.steps.1.description',
    imageAlt: 'home:how-it-works.steps.1.image',
  },
  {
    imageSrc: tailWags,
    number: 'home:how-it-works.steps.2.number',
    action: 'home:how-it-works.steps.2.action',
    description: 'home:how-it-works.steps.2.description',
    imageAlt: 'home:how-it-works.steps.2.image',
  }
]
